export const LANG = {
    appointmentBased: 'Sur rendez-vous',
    at: 'à',
    apply: 'Appliquer',
    backToResults: 'Retour aux résultats',
    backToFitterDetails: 'Retour aux détails du monteur',
    bookAFitting: 'Réserver un ajustement',
    certifiedFitter: 'Monteur Certifié PING',
    clear: 'Effacer',
    clearAll: 'Tout effacer',
    clearFilters: 'Effacer les filtres',
    closeEventsList: 'Fermer la liste des événements',
    closed: 'Fermé',
    closesAt: 'Ferme à',
    daysOfTheWeek: {
        mon: 'Lun',
        tue: 'Mar',
        wed: 'Mer',
        thu: 'Jeu',
        fri: 'Ven',
        sat: 'Sam',
        sun: 'Dim',
        Monday: 'Lundi',
        Tuesday: 'Mardi',
        Wednesday: 'Mercredi',
        Thursday: 'Jeudi',
        Friday: 'Vendredi',
        Saturday: 'Samedi',
        Sunday: 'Dimanche',
    },
    demoDayDetails: 'Détails de la journée de démonstration',
    drivingDirections: 'Itinéraire',
    errors: {
        locationDetailsCanNotBeDislayed: 'Une erreur est survenue. Les détails de l’emplacement ne peuvent pas être affichés pour le moment.',
        filterLocationsCanNotBeDislayed: 'Une erreur est survenue. Les emplacements des monteurs ne peuvent pas être affichés pour le moment.',
    },
    eventType: 'Type d’événement',
    events: 'Événements',
    featuresAndAmenities: 'Caractéristiques et commodités',
    findAFitter: 'Trouver un monteur',
    findAPingFitter: 'TROUVER UN MONTEUR PING',
    findAPingFitterNearYou: 'Trouver un monteur PING près de chez vous',
    findingFitters: 'Recherche de monteurs',
    fittingLocationFound: 'Emplacement d’ajustement trouvé',
    fittingLocationsFound: 'Emplacements d’ajustement trouvés',
    fittersFound: 'Monteurs trouvés',
    noFittingLocationsFoundTitle: 'Aucun emplacement d’ajustement trouvé.',
    noFittingLocationsFoundDescription: 'Essayez de dézoomer ou d’ajuster vos critères de recherche.',
    filters: 'Filtres',
    filter: 'Filtrer',
    filterBy: 'Filtrer par',
    hours: 'Heures',
    kilometers: 'Kilomètres',
    loadingDetails: 'Chargement des détails',
    mapSearchBox: {
        ariaLabel: 'Trouver un monteur PING près de chez vous en utilisant l’adresse, la province ou le code postal',
        placeholder: 'Rechercher une adresse, une province ou un code postal...',
    },
    messages: {
        externalLink:
            'En cliquant sur OK, vous quittez ping.com et serez redirigé vers un site Web tiers. PING n’est pas responsable du contenu, des politiques de confidentialité ou des pratiques des sites tiers. Nous vous encourageons à consulter les politiques de confidentialité et de sécurité du site Web que vous visitez.',
    },
    miles: 'Miles',
    mobileFitting: 'Ajustement mobile',
    moreDetails: 'Plus de détails',
    noLocationsFound: 'Aucun emplacement trouvé.',
    open: 'Ouvert',
    opens: 'Ouvre',
    opensAt: 'Ouvre à',
    pingFittingExperience: 'Expérience d’ajustement PING',
    pingMobileFittingExperience: 'Expérience d’ajustement mobile PING',
    pldMilled: 'PLD Fraisé',
    powerFitterOfTheYear: 'PING Ajusteur de Puissance',
    radius: 'Rayon',
    showResults: 'Afficher les résultats',
    default: 'Par défaut',
    selectAnEvent: 'Sélectionner un événement',
    distance: 'Distance',
    sort: 'Trier',
    sortBy: 'Trier par',
    sortByDefault: 'TRIER PAR : Par défaut',
    sortByDistance: 'TRIER PAR : Distance',
    distanceIn: 'DISTANCE EN : ',
    viewAllEvents: 'Voir tous les événements',
    viewDetails: 'Voir les détails',
    walkUpAppointments: 'Rendez-vous sans rendez-vous',
    weeklyAvailability: 'Disponibilité hebdomadaire',
    footer: {
        left: [
            {
                type: 'text',
                title: 'Une expérience de fitting sur mesure comme nulle autre',
            },
            {
                type: 'text',
                description:
                    'Que votre fitting ait lieu dans une baie de frappe de magasin de golf, sur un terrain de pratique, aux PING Proving Grounds ou lors de l’un des nombreux PING Fitting Days organisés chaque saison, vous apprécierez l’expertise en fitting sur mesure et le service personnalisé qui distinguent une expérience de fitting PING.',
            },
            {
                type: 'link',
                key: 'fittingProcessUrl',
                href: 'https://next.ping.com/en-us/fitting',
                text: 'Notre processus de fitting',
            },
        ],
        fittingExperience: {
            legends: [
                {
                    badgeText: 'EXPÉRIENCE DE RÉGLAGE PING',
                    badgeIcon: 'logo',
                    badgeColor: 'purple',
                    title: 'Expérience de Réglage PING',
                    links: [
                        {
                            key: 'scheduleFittingUrl',
                            href: 'https://calendly.com/pingfittingexperience',
                            text: 'Planifier un Ajustement',
                        },
                    ],
                    paragraphs: [
                        'Les ajusteurs employés par PING, formés et basés au siège social de Phoenix, effectuent des ajustements de sac complet et de club individuel au Kierland Golf Club de Scottsdale.',
                    ],
                },
                {
                    badgeText: 'PING Ajusteur de Puissance',
                    badgeIcon: 'power',
                    badgeColor: 'green',
                    title: 'PING Ajusteur de Puissance',
                    paragraphs: [
                        'Un honneur exclusif réservé aux meilleurs ajusteurs PING qui démontrent une expertise dans l’ajustement personnalisé de chaque club du sac avec le plus haut niveau de service personnalisé.',
                    ],
                },
                {
                    badgeText: 'MONTEUR CERTIFIÉ PING',
                    badgeIcon: 'ribbon',
                    badgeColor: 'blue',
                    title: 'Monteur Certifié PING',
                    paragraphs: [
                        'Experts certifiés dans l’ensemble du processus de montage PING (bois métalliques, fers, coins et putters) ayant suivi plusieurs cours de formation sur le montage et la science du golf de PING.',
                    ],
                },
                {
                    badgeText: 'PLD',
                    badgeIcon: 'pld',
                    badgeColor: 'orange',
                    title: 'PLD Fraisé',
                    paragraphs: [
                        'Les experts en ajustement de putter mesurent votre coup de putting et déterminent le meilleur putter PLD (Putting Lab Design) pour votre jeu.',
                    ],
                },
            ],
        },
    },
}
